/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observable, action, computed, makeObservable } from 'mobx';

import BrowserDetector from 'utils/browser-detector';
import localStorage from 'utils/localstorage';

const DOWNTIME_START_DATE = new Date(Date.UTC(2025, 2, 17, 7, 0));
const DOWNTIME_END_DATE = new Date(Date.UTC(2025, 2, 17, 7, 30));
const DOWNTIME_STORAGE_KEY = `modeler.downtime.seen.${DOWNTIME_END_DATE.valueOf()}`;

class TopBannerStore {
  hasSeenOutdatedBrowserMessage = !!localStorage.getItem('hasSeenOutdatedBrowserMessage');
  hasDismissedDownTimeBanner = localStorage.getItem(DOWNTIME_STORAGE_KEY) === 'true';

  constructor() {
    makeObservable(this, {
      hasSeenOutdatedBrowserMessage: observable,
      hasDismissedDownTimeBanner: observable,
      hideOutdatedBrowserMessage: action,
      isOutdatedBrowserMessageVisible: computed,
      hideDownTimeBanner: action,
      isDownTimeBannerVisible: computed
    });
  }

  hideOutdatedBrowserMessage = () => {
    localStorage.setItem('hasSeenOutdatedBrowserMessage', new Date());
    this.hasSeenOutdatedBrowserMessage = true;
  };

  hideDownTimeBanner = () => {
    localStorage.setItem(DOWNTIME_STORAGE_KEY, 'true');
    this.hasDismissedDownTimeBanner = true;
  };

  get isOutdatedBrowserMessageVisible() {
    return !this.hasSeenOutdatedBrowserMessage && !new BrowserDetector().isSupported();
  }

  get isDownTimeBannerVisible() {
    return !this.hasDismissedDownTimeBanner && Date.now() < DOWNTIME_END_DATE.getTime();
  }

  get downTimeSchedule() {
    const options = {
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short'
    };

    return {
      // @ts-expect-error TS2769
      startTime: new Intl.DateTimeFormat('en', options).format(DOWNTIME_START_DATE),
      // @ts-expect-error TS2769
      endTime: new Intl.DateTimeFormat('en', options).format(DOWNTIME_END_DATE),
      startDate: new Intl.DateTimeFormat('en', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(DOWNTIME_START_DATE),
      endDate: new Intl.DateTimeFormat('en', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(DOWNTIME_END_DATE)
    };
  }
}

export default new TopBannerStore();
